import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { getImageUrl, Languages, getCurrentLang } from '~/common';

const API_TIME_FORMAT = 'YYYYMMDDHHmmss';
const UI_DATE_TIME_FORMAT = getCurrentLang() === Languages.en_us ? 'DD MMM YYYY (ddd) h:mm a' : 'YYYY年MM月DD日 (ddd) h:mm a';

class TrainDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {

    }

    render() {
        const { detail } = this.props;
        if (!detail) return null;
        const stations = detail.Segments.reduce((a, b) => [...new Set([...a, b.FromSiteCode, b.ToSiteCode])], []);
        const trainNumbers = detail.Segments.reduce((a, b) => [...a, `${b.TrainNo}`], []);
        const seats = detail.Segments.reduce((a, b) => [...new Set([...a, b.SeatName])], []).filter(Boolean);
        return (
            <div className='detail-flight-item'>
                <div className='routing-brief'>
                    {stations.join('-')}
                </div>
                <div className='routing-detail'>
                    <div className='routing-detail-title'>
                        <div className='left-col'>
                            <div className='flight-number-font'>{`${trainNumbers.join(', ')} / ${seats.join(', ')}`}</div>
                        </div>
                        <div className="right-col">
                            <FormattedMessage id='amenities' />
                        </div>
                    </div>
                    {detail.Segments.map((segment, index) => {
                        let transferNode = null;
                        if (index > 0) {
                            const prevSegment = detail.Segments[index - 1];
                            const transferDuration = moment(segment.FromDateTimeRemark, API_TIME_FORMAT).diff(moment(prevSegment.ToDateTimeRemark, API_TIME_FORMAT), 'minutes');
                            transferNode = <div className='transfer-info'>
                                <FormattedMessage id='duration_fmt' values={{ hours: parseInt(transferDuration / 60), minutes: transferDuration % 60 }} />
                                <span className="transfer-key"><FormattedMessage id='stopover' /></span>
                                {`${segment.FromStationName || segment.FromSiteCode} (${segment.FromSiteCode})`}
                            </div>;
                        }
                        const elapsedTime = moment(segment.ToDateTimeRemark, API_TIME_FORMAT).diff(moment(segment.FromDateTimeRemark, API_TIME_FORMAT), 'minutes');
                        return <Fragment key={index}>
                            {transferNode}
                            <div className='segment-item'>
                                <div className='segment-item-info'>
                                    <div className='date-airport-info'>
                                        <div>{moment(segment.FromDateTimeRemark, API_TIME_FORMAT).format(UI_DATE_TIME_FORMAT).toUpperCase()}</div>
                                        <div>{`${segment.FromStationName || segment.FromSiteCode} (${segment.FromSiteCode})`}</div>
                                    </div>
                                    <div className='elapsed-time-info'>
                                        <FormattedMessage id='travel_time1_fmt' values={{ hours: parseInt(elapsedTime / 60), minutes: elapsedTime % 60 }} />
                                    </div>
                                    <div className='date-airport-info'>
                                        <div>{moment(segment.ToDateTimeRemark, API_TIME_FORMAT).format(UI_DATE_TIME_FORMAT).toUpperCase()}</div>
                                        <div>{`${segment.ToStationName || segment.ToSiteCode} (${segment.ToSiteCode})`}</div>
                                    </div>
                                </div>
                                <div className='segment-facility'>
                                    {segment.Facilities && segment.Facilities.length ? <Fragment>
                                        {segment.Facilities.map((facility, fIndex) => {
                                            return <div className='facility-item' key={fIndex}>
                                                <img src={getImageUrl(`${facility.key}.png`)} alt={facility.key} />
                                                <span>{facility.value}</span>
                                            </div>;
                                        })}
                                    </Fragment> : <div>
                                        <FormattedMessage id='amenities_not_found' />
                                    </div>}
                                </div>
                            </div>
                        </Fragment>;
                    })}
                </div>
            </div>
        );
    }
}

TrainDetail.propTypes = {
    detail: PropTypes.object.isRequired,
}

export default TrainDetail;